import Panel, { PanelTitle, PanelSpacer } from 'components/layout/Panel'
import { H6, Body2, Subtitle2 } from 'components/layout/text'
import Spacer from 'components/misc/Spacer'
import styled from 'styled-components/macro'
import { mediaSizeSelector } from 'selectors'
import media from 'styles/mixins/media'
import { connect } from 'react-redux'
import Icon from 'components/misc/Icon'
import VideoPlayer from 'components/misc/Vimeo'
import { ExternalLink } from 'components/layout/links'
import { LocalizedText } from 'localization'

const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const InfoWrapper = styled(CenterWrapper)`
  padding: 3rem;

  > div {
    width: 100%;
  }
`

const Info = (props) => (
  <InfoWrapper>
    <div>
      <H6>{props.title}</H6>
      <Spacer height="2.4rem" />
      {props.children}
      <Body2 pre>{props.description}</Body2>
    </div>
  </InfoWrapper>
)

const Thumbnail = styled.div`
  ${media('desktop', 'tablet', 'ultrawide')`
    width: 34rem;
    height: 20rem;
  `}
  ${media.mobile`
    width: 100%;
    height: 0;
    padding-top: 56.5%;
  `}
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
`

const VideoWrapper = styled(CenterWrapper)`
  ${media('desktop', 'tablet', 'ultrawide')`
    width: 34rem;
    height: 20rem;
  `}
  ${media.mobile`
    width: 100%;
  `}
  background: #f0f0f0;
`

const Wrapper = styled.div`
  display: flex;

  ${InfoWrapper} {
    flex-grow: 1;
    flex-shrink: 1;
  }

  ${Thumbnail}, ${VideoWrapper} {
    flex-grow: 0;
    flex-shrink: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`

const Link = (props) => (
  <ExternalLink href={props.item.url}>
    <Wrapper>
      <Info title={props.item.title} description={props.item.description} />
      <Thumbnail src={props.item.thumbnail} />
    </Wrapper>
  </ExternalLink>
)

const Video = (props) => (
  <Wrapper>
    <VideoWrapper>
      <VideoPlayer url={props.item.url} />
    </VideoWrapper>
    <Info title={props.item.title} description={props.item.description} />
  </Wrapper>
)

const MobileTitle = styled(H6)`
  padding: 1.6rem;
`

const MobileDesc = styled(Body2)`
  padding: 1.6rem;
`

const MobileLinkWrapper = styled(ExternalLink)`
  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`

const MobileVideoWrapper = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`

const MobileLink = (props) => (
  <MobileLinkWrapper href={props.item.url} target="blank">
    <MobileTitle>{props.item.title}</MobileTitle>
    <Thumbnail src={props.item.thumbnail} />
    <MobileDesc pre>{props.item.description}</MobileDesc>
  </MobileLinkWrapper>
)

const MobileVideo = (props) => (
  <MobileVideoWrapper>
    <MobileTitle>{props.item.title}</MobileTitle>
    <VideoWrapper>
      <VideoPlayer width={document.body.offsetWidth} height={document.body.offsetWidth * 0.565} url={props.item.url} />
    </VideoWrapper>
    <MobileDesc pre>{props.item.description}</MobileDesc>
  </MobileVideoWrapper>
)

function getItemComponent(media) {
  if (media === 'mobile') {
    return { video: MobileVideo, link: MobileLink }
  } else {
    return { video: Video, link: Link }
  }
}

const Section = connect(mediaSizeSelector)((props) => (
  <>
    <PanelTitle>{props.category}</PanelTitle>
    <Panel left noPadding>
      {props.items.map((item) => {
        const Comp = getItemComponent(props.mediaSize)[item.type]
        return <Comp key={item.id} item={item} />
      })}
    </Panel>
    <PanelSpacer />
  </>
))

const Empty = styled.div`
  ${media.mobile`
    height: 100%;
  `}
  ${media('desktop', 'tablet', 'ultrawide')`
    height: 60rem;
  `}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const HowTos = (props) => {
  const { items, categories, catItemMap } = props.data
  if (categories.length) {
    return categories.map((category) => {
      const sectionItems = catItemMap[category].map((id) => items.find((item) => item.id === id))
      return <Section key={category} category={category} items={sectionItems} />
    })
  } else {
    return (
      <Empty>
        <Icon symbol="loading-bar" palette="primary" shade="dark" />
        <Spacer height="2.4rem" />
        <Subtitle2>
          <LocalizedText translationKey="dweb_misc_how_tos_were_currently_updating_our_how_tos" />
          <br />
          <LocalizedText translationKey="dweb_misc_promotions_please_check_back_later" />
        </Subtitle2>
      </Empty>
    )
  }
}

export default HowTos
